module.exports = __webpack_public_path__ + "img/dog_face.a96f6cf1.gif";